"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectLink = void 0;
const react_1 = __importStar(require("react"));
const LinkButton_1 = require("../controls/LinkButton");
const helpers_1 = require("../helpers");
const Modal_1 = require("../Modal");
exports.SelectLink = (0, helpers_1.createUIElement)('SelectLink', (_a, ref) => {
    var { className, renderModal, modalProps, id, disabled, error, contentIconBefore, contentIconAfter, renderContent, emptyText, textRenderer, compact, onFocus, onBlur, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "renderModal", "modalProps", "id", "disabled", "error", "contentIconBefore", "contentIconAfter", "renderContent", "emptyText", "textRenderer", "compact", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const [modal, modalActions] = (0, Modal_1.useModal)(Object.assign(Object.assign({}, modalProps), { render: renderModal, ['data-selector-id']: 'select-link-modal-overlay' }));
    if (typeof emptyText === 'string') {
        console.warn('@Deprecated: emptyText has been removed and is not recommended for use. Use "renderContent" property');
        if (!textRenderer && !renderContent) {
            renderContent = () => emptyText;
        }
    }
    if (typeof textRenderer === 'function') {
        console.warn('@Deprecated: textRenderer has been renamed and changed injected props, is not recommended for use. Use "renderContent" property');
        if (!renderContent) {
            renderContent = () => textRenderer(emptyText);
        }
    }
    if (!textRenderer && !renderContent) {
        console.warn('SelectLink Error: renderContent must be set');
    }
    const clickHandle = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!disabled && !modalActions.isActive) {
            modalActions.activate();
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [disabled, modalActions, onClick]);
    const keyDownHandler = (0, react_1.useCallback)((e) => {
        if (!disabled && !modalActions.isActive) {
            modalActions.activate();
        }
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    }, [disabled, modalActions, onKeyDown]);
    const dataSelectorId = (0, react_1.useMemo)(() => rest['data-selector-id'] || id || 'select-link', [id, rest]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(LinkButton_1.LinkButton, Object.assign({}, rest, { ref: ref, style: style, disabled: disabled, error: error, iconBefore: contentIconBefore, compact: compact, iconAfter: contentIconAfter, onFocus: onFocus, onBlur: onBlur, onClick: clickHandle, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: keyDownHandler, onKeyUp: onKeyUp, onKeyPress: onKeyPress, "data-selector-id": dataSelectorId, className: (0, helpers_1.cn)('vm-SelectLink', className) }), renderContent === null || renderContent === void 0 ? void 0 : renderContent({ error, disabled })),
        modal));
});
//# sourceMappingURL=SelectLink.js.map